// Extracted as method for test mocking purposes
export const getLocation = () => document.location
